const SET_SELECTED = 'SET_SELECTED'

export { SET_SELECTED }
